import React from "react";

// Описания для кнопки «?» простым языком. Один источник для всех площадок.

export const PRICING_OVERVIEW_HELP = (
    <>
        <p>Здесь задаётся, по какой цене товар уходит на площадку.</p>
        <p>
            Мы считаем, сколько денег нужно получить с товара (закупка + расходы + прибыль), и делим на долю, которая
            остаётся после комиссий площадки. Так прибыль остаётся чистой, а не съедается комиссией.
        </p>
        <p>Пример: закупка 200, фикс 15, прибыль 60 → нужно получить 275. При комиссиях 12 % цена 275 ÷ 0,88 = 312,50.</p>
        <p>
            «Старая цена» — расчёт как раньше (цена магазина для площадок). «От безубыточности» — новая формула. Режим
            переключается в профиле.
        </p>
    </>
);

export const BREAKEVEN_HELP = (
    <>
        <p>Это расходы площадки без нашей прибыли — цена, при которой мы выходим в ноль.</p>
        <ul>
            <li><b>Проценты от цены</b> — комиссия площадки, эквайринг и прочее. Берутся от цены продажи.</li>
            <li><b>Фикс на товар</b> — гривны с каждой единицы: упаковка, обработка.</li>
            <li><b>Затраты по диапазонам</b> — дополнительная сумма в зависимости от закупочной цены. Можно оставить 0.</li>
            <li><b>Прибыль по умолчанию</b> — сколько гривен чистыми хотим с товара. У отправителя можно задать свою.</li>
        </ul>
        <p>Перед переключением на «От безубыточности» стоит сравнить старые и новые цены — команда показана при переключении.</p>
    </>
);

export const RULES_HELP = (
    <>
        <p>Исключения для брендов и отдельных товаров. Правило на товар сильнее правила на бренд.</p>
        <ul>
            <li><b>Скидка от РРЦ</b> — цена = РРЦ минус процент.</li>
            <li><b>Своя прибыль</b> — вместо общей прибыли берётся другая сумма.</li>
            <li><b>Фиксированная цена</b> — ровно эта цена до даты окончания.</li>
            <li><b>Скидка от расчётной</b> — процент от цены, которую посчитала формула.</li>
        </ul>
        <p>
            Если цена по правилу ниже безубыточности, правило не сработает. Включите «Разрешить ниже безубыточности»,
            если это осознанная акция.
        </p>
    </>
);

export const EXPLAIN_HELP = (
    <>
        <p>Показывает по шагам, как получилась цена товара в фиде: закупка, расходы, прибыль, деление на комиссии, правило, округление.</p>
        <p>Видно, какой отправитель выиграл и сколько реально остаётся после комиссий. Жёлтое предупреждение — товар продаётся ниже безубыточности.</p>
        <p>«Режим расчёта» позволяет посмотреть цену так, как будто аккаунт в другом режиме, — ничего не меняя.</p>
    </>
);

export const SENDERS_HELP = (
    <>
        <p>Какие поставщики участвуют на этой площадке и с какими настройками. Пустое поле — значение берётся по умолчанию (подсказка серым).</p>
        <ul>
            <li><b>Активен</b> — поставщик участвует в выгрузке.</li>
            <li><b>Приоритет</b> — при одинаковой цене выигрывает поставщик с большим приоритетом.</li>
            <li><b>Прибыль</b> — своя прибыль в гривнах для этого поставщика.</li>
            <li><b>РРЦ</b> — цена = рекомендованная цена поставщика, формула не применяется.</li>
            <li><b>Демпинг</b> — цена = закупка + розничная наценка поставщика. Действует только на этой площадке и может быть ниже безубыточности.</li>
            <li>
                <b>ТТН</b> — «Автоматически»: накладную создаём сами. «Позже вручную»: заказ получает статус 21, ТТН вносят в
                SalesDrive руками. «Как у поставщика» — берётся из карточки поставщика.
            </li>
        </ul>
        <p>Изменения применяются со следующей выгрузки (обычно до 15 минут для цен и остатков).</p>
    </>
);
